(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CouponCustom', CouponCustom);

    CouponCustom.$inject = ['$resource', 'ENV'];

    function CouponCustom($resource, ENV) {


        var getAllCompanyCoupons = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-all-company-coupons';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var evaluateCoupon = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/evaluate-coupon';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            getAllCompanyCoupons: getAllCompanyCoupons,
            evaluateCoupon: evaluateCoupon


        };
    }
})();
